'use client';

import { useCallback, useState } from 'react';

import { AcceptCookies } from '#/components/AcceptCookies/AcceptCookies';
import {
  useEnvironment,
  useUserEnvironmentActions,
} from '#/contexts/UserEnvironmentContext';
import { useIsClient } from '#/hooks/useIsClient';
import { postJson } from '#/utils/http/postJson';

export function AcceptCookiesContainer() {
  const [submitting, setSubmitting] = useState(false);

  const { updateEnvironmentPartially } = useUserEnvironmentActions();
  const { environment } = useEnvironment();
  const isClient = useIsClient();

  const acceptCookies = useCallback(async () => {
    setSubmitting(true);

    await postJson('/data/website/accept-cookies');
    updateEnvironmentPartially({ showAcceptCookies: false });
    setSubmitting(false);
  }, [updateEnvironmentPartially]);

  if (!environment.showAcceptCookies || !isClient) return null;

  return (
    <div
      style={{
        position: 'sticky',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 9999,
      }}
    >
      <AcceptCookies
        // TODO: Fix this the next time the file is edited.
        // oxlint-disable-next-line @typescript-eslint/no-misused-promises
        onAcceptCookies={acceptCookies}
        submitting={submitting}
      />
    </div>
  );
}
